<template>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <div v-if="showModal">
      <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
           aria-labelledby="productModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="productModalLabel">{{ info.name }}</h5>
              <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </b-button>
            </div>
            <div class="modal-body">
              <div class="desc-block">
                Активная бронь:
                <span class="bold-el">
                  {{ info.activeBron }}
                  <span class="light-span" v-if="activeBronOrders.length > 0">
                    ({{ activeBronOrders.join(', ') }})
                  </span>
                </span>
              </div>
              <div class="desc-block">
                Забронировано:
                <span class="bold-el">
                  {{ info.bron }}
                  <span class="light-span" v-if="bronOrders.length > 0">
                    ({{ bronOrders.join(', ') }})
                  </span>
                </span>
              </div>
              <div class="desc-block">
                Активных:
                <span class="bold-el">
                  {{ info.active }}
                  <span class="light-span"  v-if="activeOrders.length > 0">
                    ({{ activeOrders.join(', ') }})
                  </span>
                </span>
              </div>
              <div class="desc-block">
                Стоимость оборудования:
                <span class="bold-el">
                  {{ info.equipmentCost.toFixed(2) }} BYN
                </span>
              </div>

              <div class="desc-block">
                <div>Комплектация:</div>
                <div class="bold-el">{{ info.complectation }}</div>
              </div>

              <div class="desc-block">
                <div>Описание:</div>
                <div class="bold-el">{{ info.description }}</div>
              </div>

              <div class="desc-block">
                <div>Серийный номер:</div>
                <div class="bold-el"> {{ info.serialNumber }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style>
span.light-span {
  font-weight: 400;
}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import velocity from "velocity-animate";

export default {
  name: "ShowProductAdditionalInfo",
  components: {},
  data() {
    return {};
  },
  computed: {
    info: {
      get() {
        return this.$store.state.productAdditionalInfo;
      },
    },
    showModal: {
      get() {
        return this.$store.state.productAdditionalInfoModal;
      },
    },
    activeBronOrders() {
      if (!this.info.orders) return [];
      const oneWeekLater = new Date();
      oneWeekLater.setDate(oneWeekLater.getDate() + 7);

      return (this.info.orders.bron || [])
          .filter(order => new Date(order.rentStartDate) < oneWeekLater)
          .map(order => `№${order.id}(${order.quantity})`);
    },
    bronOrders() {
      if (!this.info.orders) return [];
      return (this.info.orders.bron || []).map(order => `№${order.id}(${order.quantity})`);
    },
    activeOrders() {
      if (!this.info.orders) return [];
      return (this.info.orders.active || []).map(order => `№${order.id}(${order.quantity})`);
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('updateProductAdditionalInfoModal', false);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }
  },
};

</script>
